var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1610)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1610)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_1610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6016 1.04346H9.42965C7.3826 1.04346 5.72314 2.70292 5.72314 4.74997V8.27497C5.72314 10.322 7.3826 11.9815 9.42965 11.9815H9.6016C11.6487 11.9815 13.3081 10.322 13.3081 8.27497V4.74997C13.3081 2.70292 11.6487 1.04346 9.6016 1.04346Z",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3179 5.87731C12.1142 5.87731 8.3886 6.38361 8.60832 4.28198C8.44592 5.84865 7.0321 5.87731 5.73291 5.87731",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71289 9.02966C8.71289 9.02966 9.46757 9.6697 10.2127 9.02966",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00636 22.9864H4.05148C2.37973 22.9864 1.01367 21.7254 1.01367 20.1683V19.8913C1.01367 16.3663 4.08969 13.5004 7.88218 13.5004V11.9911",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71289 19.7958V22.9864",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3276 14.0736C9.75441 14.1978 8.92331 14.15 7.8916 13.4908",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2065 11.9814V13.08",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5375 18.6398C13.5375 18.6398 11.6843 18.9264 11.627 20.2351C11.627 20.2351 12.4485 21.3432 12.0473 22.394",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5375 18.6398C13.5375 18.6398 11.6843 18.9264 11.627 20.2351C11.627 20.2351 12.4485 21.3432 12.0473 22.394",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4009 22.9195L15.5533 22.7189V18.9933L12.7543 18.8787",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4009 22.9195L15.5533 22.7189V18.9933L12.7543 18.8787",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 20.13C11.627 19.3754 12.0855 18.7258 12.7542 18.4105Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 20.13C11.627 19.3754 12.0855 18.7258 12.7542 18.4105",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6929 18.2577C18.61 18.4392 19.2883 19.2034 19.2883 20.1301V22.0788C19.2883 22.5756 18.8679 22.9768 18.3521 22.9768H12.7732C12.3624 22.9768 12.009 22.7762 11.7988 22.4705",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6929 18.2577C18.61 18.4392 19.2883 19.2034 19.2883 20.1301V22.0788C19.2883 22.5756 18.8679 22.9768 18.3521 22.9768H12.7732C12.3624 22.9768 12.009 22.7762 11.7988 22.4705",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.343 20.7988C15.9075 20.7988 16.3651 20.3625 16.3651 19.8244C16.3651 19.2862 15.9075 18.85 15.343 18.85C14.7784 18.85 14.3208 19.2862 14.3208 19.8244C14.3208 20.3625 14.7784 20.7988 15.343 20.7988Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1748 12.7648C13.1748 12.7648 10.1274 12.6597 10.1274 15.411C10.1274 16.7579 11.035 17.1878 12.1718 16.6051",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1748 12.7648C13.1748 12.7648 10.1274 12.6597 10.1274 15.411C10.1274 16.7579 11.035 17.1878 12.1718 16.6051",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3428 16.7771V18.6399",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9005 12.3255C16.0598 11.8478 14.7033 11.8574 13.8818 12.3255C12.5444 13.0897 12.1241 15.2582 12.2674 16.6147C12.4298 18.1814 13.8913 18.7928 15.3911 18.8501C16.8909 18.7928 18.3525 18.1814 18.5149 16.6147C18.6582 15.2582 18.2379 13.0897 16.9005 12.3255Z",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5596 12.7648C17.5596 12.7648 20.6069 12.6597 20.6069 15.411C20.6069 16.7579 19.6994 17.1878 18.5626 16.6051",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5596 12.7648C17.5596 12.7648 20.6069 12.6597 20.6069 15.411C20.6069 16.7579 19.6994 17.1878 18.5626 16.6051",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6585 15.8887H15.0375C14.6366 15.8887 14.3115 16.2137 14.3115 16.6147C14.3115 17.0157 14.6366 17.3407 15.0375 17.3407H15.6585C16.0594 17.3407 16.3845 17.0157 16.3845 16.6147C16.3845 16.2137 16.0594 15.8887 15.6585 15.8887Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5784 3.28841C20.5784 3.28841 18.6869 2.18983 18.2762 3.78516C18.2762 3.78516 17.9514 5.73394 20.5498 7.14776C20.5498 7.14776 23.1672 5.66707 22.9189 3.88069C22.9189 3.88069 22.8233 1.95101 20.5784 3.27886V3.28841Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85107 19.7959H10.0795C10.9393 19.7959 11.6367 20.4837 11.6367 21.3435V21.439C11.6367 22.2892 10.9393 22.9866 10.0795 22.9866H4.38603",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5492 7.14778C20.2244 6.90896 18.1992 5.65753 18.1992 4.43477V4.18639C18.1992 3.48903 18.7724 2.92542 19.4793 2.92542H19.5271C19.9665 2.92542 20.3582 3.14513 20.5874 3.47948",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5492 7.1477C20.2244 6.90888 18.1992 5.65746 18.1992 4.43469",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6071 7.14778C20.9319 6.90896 22.9571 5.65753 22.9571 4.43477V4.18639C22.9571 3.48903 22.3839 2.92542 21.677 2.92542H21.6292C21.1898 2.92542 20.7981 3.14513 20.5688 3.47948",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6064 7.1477C20.9312 6.90888 22.9564 5.65746 22.9564 4.43469",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_1610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFill);
export default __webpack_public_path__ + "static/media/icon-user-fill.de0cddca290a71baaaa00508800f74f9.svg";
export { ForwardRef as ReactComponent };